import { jsx as _jsx } from "react/jsx-runtime";
import { getOrgaosEmissoresRG } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'sigla', headerName: 'Sigla', width: 200 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function OrgaosEmissoresRG() {
    return (_jsx(GridBase, { pagina: PAGINAS.ORGAOS_EMISSORES_RG, paginaPermissao: FUNCIONALIDADES.ORGAOS_EMISSORES_RG, rota: ROUTES.ORGAOS_EMISSORES_RG, fetchData: function (str, _, pag) { return getOrgaosEmissoresRG(str, pag); }, columns: COLUNAS }));
}
